import {
    UPLOAD_DATA_TOPIC_DETAILS_MODAL_I18N_KEYS
  } from '../../../../../features/topics/components/constants/i18n/UploadDataTopicDetailsModali18nConstants';
  
  export const UPLOAD_DATA_TOPIC_DETAILS_MODAL_I18N_EN = {
    [UPLOAD_DATA_TOPIC_DETAILS_MODAL_I18N_KEYS.modal_title]:                                "Enter topic details",
    [UPLOAD_DATA_TOPIC_DETAILS_MODAL_I18N_KEYS.step_one]:                                   "1",
    [UPLOAD_DATA_TOPIC_DETAILS_MODAL_I18N_KEYS.topic_name]:                                 "Topic Name*",
    [UPLOAD_DATA_TOPIC_DETAILS_MODAL_I18N_KEYS.topic_name_missing_error]:                   "Please enter a topic name",
    [UPLOAD_DATA_TOPIC_DETAILS_MODAL_I18N_KEYS.topic_name_already_exists_error]:            "A topic already exists with that name",
    [UPLOAD_DATA_TOPIC_DETAILS_MODAL_I18N_KEYS.description]:                                "Description",
    [UPLOAD_DATA_TOPIC_DETAILS_MODAL_I18N_KEYS.description_instructions]:                   "Maximum 150 characters",
    [UPLOAD_DATA_TOPIC_DETAILS_MODAL_I18N_KEYS.categories]:                                 "Categories",
    [UPLOAD_DATA_TOPIC_DETAILS_MODAL_I18N_KEYS.categories_instructions]:                    "Enter a category or select one from the list. Separate categories with commas.",
    [UPLOAD_DATA_TOPIC_DETAILS_MODAL_I18N_KEYS.email_when_ready]:                           "Email When Ready?",
    [UPLOAD_DATA_TOPIC_DETAILS_MODAL_I18N_KEYS.cancel_button_text]:                         "CANCEL",
    [UPLOAD_DATA_TOPIC_DETAILS_MODAL_I18N_KEYS.proceed_button_text]:                        "PROCEED",
    [UPLOAD_DATA_TOPIC_DETAILS_MODAL_I18N_KEYS.save_button_text]:                           "SAVE"
  };


// WEBPACK FOOTER //
// ./src/locales/en/features/topics/components/upload_data_topic_details_modal.i18n.en.js